<template>
  <div class="experienceBranding">
    <adx-sidebar />
    <div class="container-router">
      <!-- Hidden for a while until other channel ready. -->
      <!-- <adx-sub-menubar :listUrl="subMenuList" /> -->
      <adx-jumbotron
      :image="jumbotronImg"
      :image-mobile="jumbotronImgMobile"
      :title="'Experience Branding'"
      :smallTitle="'ADX ASIA'"/>
      <div class="experienceBranding__collections">
        <div class="experienceBranding__collections__title">
          <h2 class="experienceBranding__collections__title__subtitle small-title">Best Placement for your Advertisement</h2>
        </div>
        <p class="experienceBranding__collections__subtitle">Advertising and marketing campaigns are easy, but engaging with consumers can be difficult. So what? Leverage existing partnerships for something bigger</p>
        <div v-if="isLoadingCol" class="package-wrapper-load">
          <adx-loading />
        </div>
        <div v-else class="experienceBranding__collections__cardslider__content-doc">
          <collection-card v-for="(category, index) in exBrandingCategory" 
            :key="index" :img="category.img" :title="category.title" :price="category.price" :description="category.description" :link="category.link"/>
        </div>
      </div>
      <div v-if="isLoadingCol">
        <adx-loading />
      </div>
      <div v-else v-for="(group, index) in collectionGroups" :key="index"
        class="experienceBranding__collections">
        <div class="experienceBranding__collections__title">
          <h2 class="experienceBranding__collections__title__subtitle small-title">{{group.title}}</h2>
          <span @click.stop="allCollection(group.id)" class="mobile-ic-right"><i class="adx-ic_chevron_right"></i></span>
          <button class="link desktop" @click.stop="allCollection(group.id)">See all <span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
        </div>
        <p v-if="group.description" class="experienceBranding__collections__subtitle">{{group.description}}</p>
        <div v-if="isLoadingCol" class="package-wrapper-load">
          <adx-loading />
        </div>
        <div v-else class="experienceBranding__collections__cardslider">
          <adx-card-slider
          :data="group.list"
          :slide="4"
          :slideMobile="2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/Desktop'
import SubMenuBar from '@/components/SubMenuBar'
import Jumbotron from '@/components/Jumbotron/Category'
import CategoryCard from '@/components/Card/CategoryCard'
import CardSlider from '@/components/Slider/CardSlider'
import CollectionCard from '@/components/Card/CollectionCard'
import Media from "vue-media"
import Loading from '@/components/Loading/Primary'
import api from '@/api/'
import { apiV2 } from '@/api/urls'

export default {
  name: "adx-digital-screens",
  components: {
    "adx-jumbotron": Jumbotron,
    "adx-sidebar": SideBar,
    "adx-category-card": CategoryCard,
    "adx-card-slider": CardSlider,
    "adx-sub-menubar": SubMenuBar,
    "adx-loading": Loading,
    "media": Media,
    "collection-card": CollectionCard
  },
  head: {
    title: {
      inner: 'Digital Screen',
    }
  },
  created() {
    let file = `/static/data/menus.json`;
    (async () => {
      let request = await fetch(new Request(file));
      let data = await request.json();

      this.subMenuList = data.channels;
    })();
    this.getCollections()
  },
  data() {
    return {
      jumbotronImg: '/img/ex_branding/EB-Banner.png',
      jumbotronImgMobile: '/img/ex_branding/EB-Banner.png',
      showMore: false,
      subMenuList: [],
      isLoadingCol: true,
      collectionTitle: '',
      collectionDesc: '',
      exBrandingCategory: [
        {
          title: 'SPBU',
          img: '/img/ex_branding/EB_SPBU.png',
          link: '/experience/spbu',
          description: 'ADX bisa bantu Anda beriklan di 102 outlets tempat teramai di Indonesia.'
        },
        {
          title: 'Malls',
          img: '/img/ex_branding/EB_Malls.png',
          link:'/experience/malls/',
          description: 'ADX menyediakan space iklan untuk Anda di tempat hangout paling ramai di Jakarta.'   
        },
        {
          title: 'Lifestyle',
          img: '/img/ex_branding/EB_Lifestyle.png',
          link: '/experience/lifestyle/',
          description: 'Temui pelanggan baru Anda di tempat-tempat hangout favorit mereka dengan bantuan ADX.'
        },
        {
          title: 'Airport Lounge',
          img: '/img/ex_branding/EB_Airport_lounge.png',
          link: '/experience/airport_lounge/',
          description: 'Jangkau ribuan traveller setiap harinya dengan memasang iklan di berbagai titik perjalanan mereka.'
        },
      ],
      collectionsSlider: [
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/airport_lounge.jpg',
          title: 'Airport',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/gym.jpg',
          title: 'Sport Area',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/office_building.jpg',
          title: 'Office Building',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        },
        {
          img: '/img/collection/cafe&restaurant.jpg',
          title: 'Great Jakarta',
          price: '15000',
          description: `It's a big holiday on most brands calendars, especially those selling seasonal products.`,
          link: 'home'
        }
      ],
      collectionGroups: []
    }
  },
  methods: {
    toggleMore() {
      this.showMore = !this.showMore
    },
    getCollections() {
      (async () => {
        this.isLoadingCol = true
        this.collectionGroups = []
        // const { data } = await api.get(apiV2.collectionAdvertiserList('digitalscreen'), { needToken: false })
        // this.collectionGroups = data.data.map(col => {
        //   return {
        //     ...col,
        //     list: col.list.map(item => {
        //       return {
        //         ...item,
        //         img: col.layout_id == 'RE' ? item.square_thumbnail : item.landscape_thumbnail
        //       }
        //     })
        //   }
        // })
        this.isLoadingCol = false
      })();
    },
    allCollection(id) {
      this.$router.push({ name: 'collectioncategory', params: { category: id } })
    }
  },
  computed: {
    btnCategoryText() {
      return (this.showMore ? 'View Less' : 'View More')
    }
  }
}
</script>

<style lang="scss">
@import "./index.scss";

.experienceBranding{
  .container-router{
    .categoryJumbotron{
      margin-bottom: 48px;
    }
    .categoryJumbotron__image{
      &__layer{
         &__content{
           i{
             display: none;
           }
         }
      }
    }
  }
}

.experienceBranding__collections__cardslider__content-doc , .experienceBranding__collections__cardslider{

  .collectionCard__title span{
    font-size: 17px;
    font-weight: bold
  }

  .collectionCard__description{
    font-size: 15px;
  }
}

@include breakpoint(md){
  .experienceBranding{
    .container-router{

      .categoryJumbotron__image-mobile{
        max-height: 160px;
      }
    }
  }

  .experienceBranding__collections__title__subtitle {
    font-size: 19px;
  }
}
</style>
